// Human-friendly relative time, e.g. "just now", "5 mins ago", "3 days ago".
// Returns null for missing or zero-value timestamps (topics created before the
// createdAt field existed serialize as year 0001).
export function relativeTime(iso?: string): string | null {
  if (!iso || iso.startsWith('0001')) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;

  const secs = Math.round((Date.now() - then) / 1000);
  if (secs < 45) return 'just now';

  const ladder: { limit: number; div: number; name: string }[] = [
    { limit: 3600, div: 60, name: 'min' },
    { limit: 86400, div: 3600, name: 'hour' },
    { limit: 604800, div: 86400, name: 'day' },
    { limit: 2629800, div: 604800, name: 'week' },
    { limit: 31557600, div: 2629800, name: 'month' },
    { limit: Number.POSITIVE_INFINITY, div: 31557600, name: 'year' },
  ];
  for (const step of ladder) {
    if (secs < step.limit) {
      const value = Math.round(secs / step.div);
      return `${value} ${step.name}${value === 1 ? '' : 's'} ago`;
    }
  }
  return 'just now';
}
